"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_LEVEL_MAP = exports.DEFAULT_USER_LEVEL = exports.USER_SWITCH_ALLOWED_FOR_ROLES = void 0;
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const types_1 = require("../user/types");
exports.USER_SWITCH_ALLOWED_FOR_ROLES = [types_1.Role.SUPER_ADMIN, types_1.Role.ADMIN, types_1.Role.CUSTOMER_SUCCESS];
exports.DEFAULT_USER_LEVEL = 1;
exports.USER_LEVEL_MAP = {
    [types_1.Role.SUPER_ADMIN]: 4,
    [types_1.Role.ADMIN]: 3,
    [types_1.Role.CUSTOMER_SUCCESS]: 2,
    [types_1.Role.USER]: exports.DEFAULT_USER_LEVEL,
    [types_1.Role.DEBUGGER]: exports.DEFAULT_USER_LEVEL,
    [types_1.Role.SCOUT]: exports.DEFAULT_USER_LEVEL,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlclN3aXRjaC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMvdXNlclN3aXRjaC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7Ozs7O0dBTUc7QUFDSCwyQ0FBdUM7QUFFMUIsUUFBQSw2QkFBNkIsR0FBRyxDQUFDLFlBQUksQ0FBQyxXQUFXLEVBQUUsWUFBSSxDQUFDLEtBQUssRUFBRSxZQUFJLENBQUMsZ0JBQWdCLENBQUMsQ0FBQztBQUN0RixRQUFBLGtCQUFrQixHQUFHLENBQUMsQ0FBQztBQUN2QixRQUFBLGNBQWMsR0FBeUI7SUFDbEQsQ0FBQyxZQUFJLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQztJQUNyQixDQUFDLFlBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDO0lBQ2YsQ0FBQyxZQUFJLENBQUMsZ0JBQWdCLENBQUMsRUFBRSxDQUFDO0lBQzFCLENBQUMsWUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFLDBCQUFrQjtJQUMvQixDQUFDLFlBQUksQ0FBQyxRQUFRLENBQUMsRUFBRSwwQkFBa0I7SUFDbkMsQ0FBQyxZQUFJLENBQUMsS0FBSyxDQUFDLEVBQUUsMEJBQWtCO0NBQ2pDLENBQUMifQ==